import React from "react";
import PropTypes from "prop-types";

import Snackbar from "./Snackbar";
import { SNACKBAR_TYPE } from "../../constants/notificationType";

class SnackbarContainer extends React.Component {
  componentDidMount = () => {
    const { onRequestHide, displayTime } = this.props;
    this.timer = setTimeout(onRequestHide, displayTime);
  };

  componentWillUnmount = () => {
    if (this.timer) {
      clearTimeout(this.timer);
    }
  };

  render() {
    const { type, message } = this.props;
    return <Snackbar type={type} message={message} />;
  }
}

SnackbarContainer.defaultProps = {
  type: SNACKBAR_TYPE.INFO,
};

SnackbarContainer.propTypes = {
  message: PropTypes.string.isRequired,
  onRequestHide: PropTypes.func.isRequired,
  type: PropTypes.oneOf(Object.values(SNACKBAR_TYPE)),
  displayTime: PropTypes.number.isRequired,
};

export default SnackbarContainer;
